'use client'

import * as React from 'react'
import { Button } from '@/components/ui/deprecated-button'
import { InviteLink } from '@/components/invite-link'
import { FormControl } from '@/components/form-control'
import { useInviteLink } from '@/modules/invite/use-invite-link'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'

export function GiveToGetPracticingModal({
  isOpen,
  onClose,
  isAuthenticated,
}: {
  isOpen: boolean | null
  onClose: () => void
  isAuthenticated: boolean
}): React.JSX.Element {
  const { inviteUrl, loading: inviteLinkLoading } = useInviteLink({
    isAuthenticated,
  })

  return (
    <Dialog open={Boolean(isOpen)} onOpenChange={onClose}>
      <DialogContent
        title="Ready to see all salaries?"
        className="overflow-auto"
      >
        <DialogTitle className="text-2xl">
          Thanks for joining Marit!{' '}
        </DialogTitle>
        <p className="text-copy-primary">
          Our team will review your submission and reach out if we have any
          questions.
        </p>
        <p className="mt-3 text-copy-primary">
          Every additional clinician who joins Marit makes the data that much
          better for you and everyone else here. If you know any physicians or
          APPs please invite them to join via group text, WhatsApp, email, or
          social media!
        </p>
        <FormControl label="Invite via Personalized Link" className="mt-6">
          <InviteLink inviteUrl={inviteUrl} loading={inviteLinkLoading} />
        </FormControl>
        <Button
          className="w-full mt-6"
          size="lg"
          onClick={onClose}
          disabled={inviteLinkLoading}
        >
          See All Salaries
        </Button>
      </DialogContent>
    </Dialog>
  )
}
